import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Copyright = styled.div`
  font-size: 0.9rem;
`;

const FooterNav = styled.nav`
  ul {
    display: flex;
    list-style: none;
    gap: 20px;
  }

  li {
    font-size: ${({ theme }) => theme.fontSizes.medium};
  }
`;

const Footer = () => (
  <FooterWrapper>
    <Copyright>© 2024 Cloudetica Solutions. All Rights Reserved.</Copyright>
    <FooterNav>
      <ul>
        <li><Link to="/terms-of-service">Terms of Service</Link></li>
        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
        <li><Link to="/careers">Careers</Link></li>
      </ul>
    </FooterNav>
  </FooterWrapper>
);

export default Footer;
